import comp from "./DefaultSettingsContent";
export default comp;
